
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.195","height":"16.75"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#869398","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('g',{attrs:{"transform":"translate(.5 2.798)"}},[_c('line',{attrs:{"x1":"1.589"}}),_c('line',{attrs:{"x1":"1.589","transform":"translate(0 5.254)"}}),_c('line',{attrs:{"x1":"1.589","transform":"translate(0 10.507)"}})]),_c('path',{attrs:{"d":"M2.268.5v15.754h15.166"}}),_c('g',{attrs:{"transform":"translate(3.738 5.483)"}},[_c('line',{attrs:{"y1":"3.417","x2":"2.264","transform":"translate(11.5 -.234)"}}),_c('line',{attrs:{"x2":"1.858","y2":"1.228","transform":"translate(7.697 2.407)"}}),_c('line',{attrs:{"y1":"2.273","x2":"2.689","transform":"translate(2.997 2.544)"}}),_c('line',{attrs:{"x2":".978","y2":"1.011","transform":"translate(0 3.884)"}}),_c('circle',{attrs:{"cx":"1.103","cy":"1.103","r":"1.103","transform":"translate(9.534 2.868)"}}),_c('circle',{attrs:{"cx":"1.103","cy":"1.103","r":"1.103","transform":"translate(5.513 .76)"}}),_c('circle',{attrs:{"cx":"1.103","cy":"1.103","r":"1.103","transform":"translate(.811 4.522)"}})])])])
          )
        }
      }
    